module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1lVof"))).then(() => parcelRequire('8rm4T'));